import './style.less';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CloseIcon from '@mui/icons-material/Close';
import { Paper, Typography } from '@mui/material';
import { useCallback, useEffect } from 'react';
import type { MouseEvent as ReactMouseEvent, FC, HTMLAttributes, PropsWithChildren } from 'react';
import { useMedia } from 'react-use';

import { useZustand } from '../../../../zustandStore';

type SideMenuHeaderProps = HTMLAttributes<HTMLDivElement>;

const SideMenuHeader: FC<PropsWithChildren<SideMenuHeaderProps>> = () => {
	const isOpenOnDesktopView = useZustand(state => state.sideMenu.isOpenOnDesktopView ?? true);
	const isOpenOnMobileView = useZustand(state => state.sideMenu.isOpenOnMobileView);
	const { openSideMenuOnDesktopView, openSideMenuOnMobileView } = useZustand();
	const isMobileWidth = useMedia('(max-width: 650px)');

	const toggleIsSideMenuOpen = useCallback(
		(event: ReactMouseEvent) => {
			event.preventDefault();

			const headerElement = document.querySelector('.ts-app .ts-headerbar') as HTMLElement | null;

			if (isMobileWidth) {
				openSideMenuOnMobileView(false);
			} else {
				openSideMenuOnDesktopView(!isOpenOnDesktopView);
			}

			// If the side menu is open we remove the styles(from ts.ui) and class from the header element
			if (headerElement && (isOpenOnMobileView || isOpenOnDesktopView)) {
				headerElement.style.opacity = '1';
				headerElement.classList.remove('_gui-hidden');
			} else if (headerElement) {
				headerElement.style.opacity = '0';
				headerElement.classList.add('_gui-hidden');
			}
		},
		[isMobileWidth, isOpenOnDesktopView, isOpenOnMobileView, openSideMenuOnDesktopView, openSideMenuOnMobileView],
	);

	useEffect(() => {
		const collapseButton = document.querySelector('.side-menu-header-collapse-button');
		const closeIcon = collapseButton?.querySelector('i.ts-icon-close');

		collapseButton?.classList.toggle('hasCloseIcon', Boolean(closeIcon));
	}, []);

	return (
		<Paper
			ts-variant={isOpenOnDesktopView ? 'sideMenuHeaderPaper' : 'sideMenuHeaderCollapsed'}
			onClick={toggleIsSideMenuOpen}
		>
			<Typography
				component="div"
				ts-variant={isOpenOnDesktopView ? 'sidebarHeaderIconDiv' : 'sidebarHeaderIconCollapsedDiv'}
			>
				{isMobileWidth ? (
					isOpenOnMobileView ? (
						<CloseIcon ts-variant="mobileCloseIcon" onClick={toggleIsSideMenuOpen} />
					) : (
						''
					)
				) : (
					<ChevronRightIcon
						color="inherit"
						onClick={toggleIsSideMenuOpen}
						ts-variant="sidebarHeaderIcon"
						className={`${isOpenOnDesktopView ? 'animateLeft' : 'animateRight'}`}
					/>
				)}
			</Typography>
		</Paper>
	);
};

export default SideMenuHeader;
